import {A, E} from './util.mjs'
import * as a from '@mitranim/js/all.mjs'
import * as dr from '@mitranim/js/dom_reg.mjs'
import * as c from './conf.mjs'
import * as u from './util.mjs'
import * as d from './dat.mjs'
import * as em from './elem-misc.mjs'

export class Reactions extends em.MixExecable(u.Elem) {
  static {dr.reg(this)}

  preinit(props) {
    this.setProps(props)
    this.pageDat().inp.get.sets.reactionMetas.add(props.entId)
  }

  async init({simpleView, widthAuto} = {}) {
    const props = this.getProps()
    props.meta = this.pageDat().buk.get.sets?.reactionMetas?.get(props.entId)

    return E(this, A
      .cls(`row-sta-str gap-tiny`)
      .cls(a.vac(simpleView && widthAuto) && `w-full`)
      .test(`Reactions`)
    ).initChi(props)
  }

  async initChi({publishedAt, meta}) {
    // Imported dynamically because isn't needed on client initialization,
    // where we should import only element scripts.
    const s = await u.imp(import(`./views/svg.mjs`))

    const {totalLikes, totalDislikes, reaction} = a.laxStruct(meta)

    /*
    Careful: `isLike` is ternary, it may be true, false, or nil. False and nil
    are not the same. Meanwhile `isFav` is strictly boolean.
    */
    const {isFav, isLike} = a.laxStruct(reaction)
    const fakeLikes = c.FAKE_LIKES ? d.fakeLikesSince(publishedAt) : 0
    const showLikes = totalLikes + fakeLikes

    return E(this, {},
      E(
        `button`,
        btnProps({isFav: !isFav}, isFav, `ButtonFav`),
        isFav ? s.HeartFilled() : s.HeartEmpty(),
      ),
      E(
        `button`,
        btnProps({isLike: isLike ? null : true}, isLike === true, `ButtonLike`),
        isLike === true ? s.LikeActive() : s.Like(),
        a.vac(showLikes) && showLikes,
      ),
      E(
        `button`,
        btnProps({isLike: isLike === false ? null : false}, isLike === false, `ButtonDislike`),
        a.vac(totalDislikes) && totalDislikes,
        isLike === false ? s.DislikeActive() : s.Dislike(),
      ),
    )
  }

  connectedCallback() {this.onclick = this.exec}

  async perform(eve) {
    if (!(eve.type === `click`)) return
    const tar = u.findAncestorBetween(eve.target, this, u.isButtonBtn)
    if (!tar) return
    a.eventKill(eve)

    const props = this.getProps()
    const {entId} = props
    const actInp = a.jsonDecode(tar.dataset.props)
    actInp.entId = entId

    const inp = new d.BukInp()
    inp.act.reactions = {upsert: [actInp]}
    inp.get.sets.reactionMetas.add(entId)

    const buk = await this.pageDat().bukFetch(inp)
    props.meta = buk.get.sets.reactionMetas.get(entId)
    await this.initChi(props)
  }
}

function btnProps(props, isActive, testName) {
  return A
    .button()
    .dataProps(props)
    .cls(c.CLS_BTN_ICON_STD)
    .cls(isActive ? `--active` : ``)
    .test(testName)
}

export async function SocialReactions({ctx, ent, reactions}) {
  const sh = await u.imp(import(`./views/share.mjs`))
  const title = a.reqStr(ent.title)
  const preview = a.reqStr(ent.preview)

  return E(`div`, {class: `row-bet-cen flex-wrap w-full gap-sm`},
    sh.ShareInlined({ctx, title, preview}),
    await reactions.init(),
  )
}
